import React from 'react';
import TableColumnTitle from '../../../../../../components/_table/TableColumnTitle';
import OpenOrderItemDetail from '../../../../../../components/link/OpenOrderItemDetail';
import OpenPreviewProductDetail from '../../../../../../containers/app/common/OpenPreviewProductDetail';
import OpenProductDetail from '../../../../../../components/link/OpenProductDetail';
import Anchor from '../../../../../../components/link/Anchor';
import TableFilterSelect from '../../../../../../components/_table/TableFilterSelect';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';
import {
  ORDER_ITEM_STATUS_TEXT,
  PAY_METHOD_TYPE_TEXT,
  ORDER_DELIVERY_TYPE_TEXT,
  ORDER_RETURN_STATUS_TEXT,
  ORDER_ACCEPT_MANAGER_TEXT,
  ORDER_RETURN_TYPE_TEXT,
  RETURN_EXCHANGE_REASON_TYPE,
  ORDER_TYPE_SELECT_LIST,
  ORDER_TYPE_TEXT,
  ORDER_GIFT_STATUS_SELECT_LIST,
  ORDER_GIFT_STATUS_TEXT,
  TAKEBACK_METHOD_TEXT,
} from '../../../../../../constants/service/app/orderConstants';
import { setDash, setPhoneFormat, addAllItemToSelectList } from '../../../../../../lib/common';
import { setDateFormat } from '../../../../../../lib/moment';
import { setOrderMessage, setBuyerAccount } from '../../../../../../lib/utils/orderutils';
import OpenBrandDetail from '../../../../../../components/link/OpenBrandDetail';
import { BRAND_TYPE_TEXT } from '../../../../../../constants/service/app/brandConstants';
import { PRODUCT_MANAGEMENT_TYPE_TEXT } from '../../../../../../constants/service/app/productConstants';

const columns = (data) => {
  const { getOrderReturnAttachment, filterOption, onFilter } = data;

  return [
    {
      title: <TableColumnTitle title="주문 타입" filterValue={ORDER_TYPE_TEXT[filterOption.orderType]} />,
      dataIndex: 'orderType',
      filterDropdown: ({ confirm }) => (
        <TableFilterSelect
          list={addAllItemToSelectList(ORDER_TYPE_SELECT_LIST)}
          option={filterOption.orderType}
          confirm={confirm}
          onFilter={(orderType) => onFilter({ orderType })}
        />
      ),
      render: (value) => setDash(ORDER_TYPE_TEXT[value]),
    },
    {
      title: <TableColumnTitle title="선물 상태" filterValue={ORDER_GIFT_STATUS_TEXT[filterOption.giftStatus]} />,
      dataIndex: 'giftStatus',
      filterDropdown: ({ confirm }) => (
        <TableFilterSelect
          list={addAllItemToSelectList(ORDER_GIFT_STATUS_SELECT_LIST)}
          option={filterOption.giftStatus}
          confirm={confirm}
          onFilter={(giftStatus) => onFilter({ giftStatus })}
        />
      ),
      render: (value) => setDash(ORDER_GIFT_STATUS_TEXT[value]),
    },
    {
      title: <TableColumnTitle title={['반품 정보']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['주문번호']} />,
          dataIndex: 'orderId',
        },
        {
          title: <TableColumnTitle title={['상품 주문번호']} />,
          dataIndex: 'orderItemId',
          render: (value) => <OpenOrderItemDetail text={value} orderItemId={value} />,
        },
        {
          title: <TableColumnTitle title={['주문 메시지']} />,
          dataIndex: 'orderMessage',
          render: (value) => setOrderMessage(value),
        },
        {
          title: '스타일코드(바코드)',
          dataIndex: 'productStyleCode',
          render: (value) => setDash(value),
        },
        {
          title: '바코드',
          dataIndex: 'productOptionStyleCode',
          render: (value) => setDash(value),
        },
        {
          title: <TableColumnTitle title={['주문 상태']} />,
          dataIndex: 'orderItemStatus',
          render: (value) => ORDER_ITEM_STATUS_TEXT[value],
        },
        {
          title: <TableColumnTitle title={['반품 처리 상태']} />,
          dataIndex: 'orderItemReturnStatus',
          render: (value) => ORDER_RETURN_STATUS_TEXT[value],
        },
        {
          title: <TableColumnTitle title={['회수 방식']} />,
          dataIndex: 'isAutoTakeback',
          render: (value) => TAKEBACK_METHOD_TEXT[value],
        },
        {
          title: <TableColumnTitle title={['택배사']} />,
          dataIndex: 'takebackDeliveryEnterpriseName',
          render: (value) => value ?? '-',
        },
        {
          title: <TableColumnTitle title={['회수 송장번호']} />,
          dataIndex: 'takebackInvoiceNumber',
          render: (value) => value ?? '-',
        },
        {
          title: <TableColumnTitle title={['구매자의 환불 예정 금액']} />,
          dataIndex: 'refundExpectAmount',
          render: (value) => (value ? value.toLocaleString() : '-'),
        },
        {
          title: <TableColumnTitle title={['판매자의 환불 예정 금액']} />,
          dataIndex: 'refundSellerAmount',
          render: (value) => (value ? value.toLocaleString() : '-'),
        },
        {
          title: <TableColumnTitle title={['실제 고객 환불금액']} />,
          dataIndex: 'refundActualAmount',
          render: (value) => (value ? value.toLocaleString() : '-'),
        },
        {
          title: <TableColumnTitle title={['접수자']} />,
          dataIndex: 'acceptManager',
          render: (value) => ORDER_ACCEPT_MANAGER_TEXT[value],
        },
        {
          title: <TableColumnTitle title={['반품 사유 수정 일시']} />,
          dataIndex: 'returnReasonModifyDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
        {
          title: <TableColumnTitle title={['반품사유']} />,
          dataIndex: 'returnType',
          render: (value, record) => (
            <Anchor
              color="primary"
              text={ORDER_RETURN_TYPE_TEXT[value]}
              isUnderLine={true}
              onClick={() =>
                getOrderReturnAttachment({
                  orderReturnId: record.orderReturnId,
                  reasonType: RETURN_EXCHANGE_REASON_TYPE.RETURN_REQUEST,
                  buyerName: record.buyerName,
                  buyerAccount: record.buyerAccount,
                  date: record.requestReturnDate,
                  orderItemId: record.orderItemId,
                  buyerPhone: record.buyerPhone,
                  productName: record.productName,
                  reason: record.returnReason,
                })
              }
            />
          ),
        },
      ],
    },
    {
      title: <TableColumnTitle title={['반품 거부']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['반품 거부사유']} />,
          dataIndex: 'returnRejectReason',
          render: (value, record) =>
            value ? (
              <Anchor
                color="primary"
                text="내용 보기"
                isUnderLine={true}
                onClick={() =>
                  getOrderReturnAttachment({
                    orderReturnId: record.orderReturnId,
                    reasonType: RETURN_EXCHANGE_REASON_TYPE.RETURN_REJECT,
                    buyerName: record.buyerName,
                    buyerAccount: record.buyerAccount,
                    date: record.rejectDate,
                    orderItemId: record.orderItemId,
                    buyerPhone: record.buyerPhone,
                    productName: record.productName,
                    reason: value,
                  })
                }
              />
            ) : (
              '-'
            ),
        },
        {
          title: <TableColumnTitle title={['반품 거부 일시']} />,
          dataIndex: 'rejectDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
      ],
    },
    {
      title: <TableColumnTitle title={['반품 건 처리 일시']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['주문 일시']} />,
          dataIndex: 'orderDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
        {
          title: <TableColumnTitle title={['결제 일시']} />,
          dataIndex: 'paymentDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
        {
          title: <TableColumnTitle title={['반품 요청 일시']} />,
          dataIndex: 'requestReturnDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
        {
          title: <TableColumnTitle title={['수거 완료 일시']} />,
          dataIndex: 'receiveDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
        {
          title: <TableColumnTitle title={['반품 승인 일시']} />,
          dataIndex: 'returnCompleteDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
        {
          title: <TableColumnTitle title={['반품 완료 일시']} />,
          dataIndex: 'refundCompleteDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
      ],
    },
    {
      title: <TableColumnTitle title={['반품 비용']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['최초무료배송비']} />,
          dataIndex: 'returnDeliveryFee',
          render: (value) => (value ? value.toLocaleString() : '-'),
        },
        {
          title: <TableColumnTitle title={['추가청구비']} />,
          dataIndex: 'refundExtraFee',
          render: (value) => (value ? value.toLocaleString() : '-'),
        },
      ],
    },
    {
      title: <TableColumnTitle title={['구매자/수취인']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['구매자ID']} />,
          dataIndex: 'buyerAccount',
          render: (value) => setBuyerAccount(value),
        },
        {
          title: <TableColumnTitle title={['구매자명']} />,
          dataIndex: 'buyerName',
        },
        {
          title: <TableColumnTitle title={['수취인명']} />,
          dataIndex: 'recipientName',
        },
      ],
    },
    {
      title: <TableColumnTitle title={['구매상품 정보']} color="primary" />,
      children: [
        {
          title: '브랜드명',
          dataIndex: 'brandName',
          render: (value, record) => <OpenBrandDetail text={value} storeId={record.storeId} />,
        },
        {
          title: '브랜드 ID',
          dataIndex: 'storeId',
          render: (value) => <OpenBrandDetail text={value} storeId={value} />,
        },
        {
          title: <TableColumnTitle title={['상품번호']} />,
          dataIndex: 'productId',
          render: (value) => <OpenProductDetail text={value} productId={value} />,
        },
        {
          title: <TableColumnTitle title={['제품번호']} />,
          dataIndex: 'productNumber',
          render: (value) => setDash(value),
        },
        {
          title: '관리처',
          dataIndex: 'store',
          render: (value) => setDash(BRAND_TYPE_TEXT[value]),
        },
        {
          title: '타입',
          dataIndex: 'productType',
          render: (value) => setDash(PRODUCT_MANAGEMENT_TYPE_TEXT[value]),
        },
        {
          title: <TableColumnTitle title={['상품명']} />,
          dataIndex: 'productName',
          render: (value, record) => <OpenPreviewProductDetail text={value} productId={record.productId} />,
        },
        {
          title: '1차 카테고리',
          dataIndex: 'mainCategory',
        },
        {
          title: <TableColumnTitle title={['옵션정보']} />,
          dataIndex: 'productOption',
          render: (value) => setDash(value),
        },
        {
          title: <TableColumnTitle title={['옵션 제품번호']} />,
          dataIndex: 'productOptionNumber',
          render: (value) => setDash(value),
        },
        {
          title: <TableColumnTitle title={['수량']} />,
          dataIndex: 'quantity',
          render: (value) => (value ? value.toLocaleString() : '-'),
        },
        {
          title: <TableColumnTitle title={['상품 가격(정가)']} />,
          dataIndex: 'productPrice',
          render: (value) => (value ? value.toLocaleString() : '-'),
        },
        {
          title: <TableColumnTitle title={['상품 할인액(차감된 금액)']} />,
          dataIndex: 'discountPrice',
          render: (value) => (value ? value.toLocaleString() : '-'),
        },
        {
          title: <TableColumnTitle title={['옵션가격']} />,
          dataIndex: 'productOptionPrice',
          render: (value) => (value ? value.toLocaleString() : '-'),
        },
        {
          title: <TableColumnTitle title={['쿠폰']} />,
          dataIndex: 'usedCoupon',
          render: (value) => (value ? value.toLocaleString() : '-'),
        },
        {
          title: <TableColumnTitle title={['Apoint']} />,
          dataIndex: 'usedPoint',
          render: (value) => (value ? value.toLocaleString() : '-'),
        },
        {
          title: <TableColumnTitle title={['상품 별 총 주문금액']} />,
          dataIndex: 'totalPrice',
          render: (value) => (value ? value.toLocaleString() : '-'),
        },
        {
          title: <TableColumnTitle title={['추가 배송비']} />,
          dataIndex: 'deliveryExtraFee',
          render: (value) => (value ? value.toLocaleString() : '-'),
        },
      ],
    },
    {
      title: <TableColumnTitle title={['배송 수취 정보']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['구매자 연락처']} />,
          dataIndex: 'buyerPhone',
          render: (value) => setPhoneFormat(value),
        },
        {
          title: <TableColumnTitle title={['수취인 연락처']} />,
          dataIndex: 'recipientPhone',
          render: (value) => setPhoneFormat(value),
        },
        {
          title: <TableColumnTitle title={['배송지']} />,
          dataIndex: 'shippingAddress',
          render: (value, record) =>
            record.shippingAddress1 &&
            record.shippingAddress2 &&
            `${record.shippingAddress1} ${record.shippingAddress2}`,
        },
        {
          title: <TableColumnTitle title={['우편번호']} />,
          dataIndex: 'shippingPostCode',
        },
        {
          title: <TableColumnTitle title={['배송메시지']} />,
          dataIndex: 'shippingMessage',
          render: (value) => setDash(value),
        },
      ],
    },
    {
      title: <TableColumnTitle title={['발송 배송 정보']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle className="delivery-type" title={['배송방법']} />,
          dataIndex: 'deliveryType',
          render: (value) => setDash(ORDER_DELIVERY_TYPE_TEXT[value]),
        },
        {
          title: <TableColumnTitle className="delivery-agent" title={['택배사']} />,
          dataIndex: 'deliveryAgentName',
          render: (value) => setDash(value),
        },
        {
          title: <TableColumnTitle className="invoice-number" title={['송장정보']} />,
          dataIndex: 'invoiceNumber',
          render: (value) => setDash(value),
        },
      ],
    },
    {
      title: <TableColumnTitle title={['결제 정보']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['결제 수단']} />,
          dataIndex: 'payMethod',
          render: (value) => PAY_METHOD_TYPE_TEXT[value],
        },
      ],
    },
  ];
};

export default columns;
